import React from 'react';
import PropTypes from 'prop-types';

// Components
import {Modal, Row, Column, Form} from '@drivesally/sally-ui';
import AttributeInput from '../../../components/components/atoms/AttributeInput/AttributeInput';

// lib
import getTimeZoneFromBranch from '../../../libs/getTimeZoneFromBranch';

const PutVehicleOnHoldModal = ({
  auto_release,
  date_etc,
  hold_type,
  loading,
  onChange,
  onClose,
  onSave,
  reason,
  vehicle,
  visible,
}) => (
  <Modal
    visible={visible}
    icon="warning"
    title="Put on Hold"
    subtitle={vehicle?.svid || '-'}
    onClose={onClose}
    buttonsRight={[{label: 'Put on hold', loading, onClick: onSave}]}
    size="small"
  >
    {(Content) => (
      <Content>
        <Form onSubmit={onSave} enter>
          <Row margin>
            <Column>
              <AttributeInput
                value={hold_type}
                onChange={onChange}
                disabled={loading}
                notFilterable
              >
                {hold_type.label.default}
              </AttributeInput>
            </Column>
          </Row>
          <Row margin>
            <Column>
              <AttributeInput
                value={date_etc}
                onChange={onChange}
                disabled={loading}
                timeZone={getTimeZoneFromBranch({
                  branch: vehicle?.sally_branch,
                })}
              >
                {date_etc.label.default}
              </AttributeInput>
            </Column>
          </Row>
          <Row margin>
            <Column>
              <AttributeInput
                value={auto_release}
                onChange={onChange}
                disabled={loading}
              >
                {auto_release.label.default}
              </AttributeInput>
            </Column>
          </Row>
          <Row>
            <Column>
              <AttributeInput
                value={reason}
                onChange={onChange}
                disabled={loading}
              >
                {reason.label.default}
              </AttributeInput>
            </Column>
          </Row>
        </Form>
      </Content>
    )}
  </Modal>
);

PutVehicleOnHoldModal.propTypes = {
  auto_release: PropTypes.object,
  date_etc: PropTypes.object,
  hold_type: PropTypes.object,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  reason: PropTypes.object,
  vehicle: PropTypes.object,
  visible: PropTypes.bool,
};

export default PutVehicleOnHoldModal;
